import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-subtitle-separator',
  templateUrl: './form-subtitle-separator.component.html',
  styleUrls: ['./form-subtitle-separator.component.scss'],
})
export class FormSubtitleSeparatorComponent implements OnInit {
  @Input() title: string;
  @Input() icon: string;
  constructor() {}

  ngOnInit() {}
}
